export enum EnumUSTCopyFormField {
  masterAccountId = 'masterAccountId',
  investorId = 'investorId',
  type = 'type',
  copyType = 'copyType',
  lot = 'lot',
  leverage = 'leverage',
  ibCode = 'ibCode',
}
